import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'event-details-page';
export const useEventDetailsPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    title: 'Детали события',
    archive: 'Архив событий обнаружение и совпадение',
    title_detection: 'Обнаружение',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    title: 'Event details',
    archive: 'Event archive detection and matching',
    title_detection: 'Detection',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    title: 'Detalles del evento',
    archive: 'Archivo de eventos detección y coincidencia',
    title_detection: 'Detección',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    title: 'Detalhes do evento',
    archive: 'Arquivo de eventos detecção e correspondência',
    title_detection: 'Detecção',
  },
}) : {}) as Record<string, unknown>;
